export enum UserRole {
  USER = "ROLE_USER",
  ADMIN = "ROLE_ADMIN",
  ALL_RADIUS_CAMPAIGN = "ROLE_ALL_RADIUS_CAMPAIGN",
  ALL_SUBSCRIPTION_CAMPAIGN = "ROLE_ALL_SUBSCRIPTION_CAMPAIGN",
}

export const USER_ROLES_OPTIONS_ALLOWED_TO_ADD_VIA_ADMIN_PANEL: {
  name: string;
  id: string;
  disabled?: boolean;
}[] = [
  {
    name: "ROLE_MEDIA_BUYER",
    id: "ROLE_MEDIA_BUYER",
  },
  {
    name: "ROLE_STATISTICS_FINANCE",
    id: "ROLE_STATISTICS_FINANCE",
  },
  {
    name: "ROLE_ALL_RADIUS_CAMPAIGN",
    id: "ROLE_ALL_RADIUS_CAMPAIGN",
  },
  {
    name: "ROLE_ALL_SUBSCRIPTION_CAMPAIGN",
    id: "ROLE_ALL_SUBSCRIPTION_CAMPAIGN",
  },
];
